export default class Menu {
  constructor(node) {
    this.node = node

    this.menu = this.node.querySelector('.menu-modal')
    this.menuOpen = this.node.querySelector('.menu-button--open')
    this.menuClose = this.node.querySelector('.menu-button--close')
    this.menuState = false

    this.menuLinks = Array.from(
      document.querySelectorAll('.main-menu-link:not(.main-menu-link--tickets)')
    )

    this.clickAction = this.clickAction.bind(this)

    this.currentPage = this.getCurrentPageName()

    this.setActiveMenuItem()

    this.init()
  }

  init() {
    this.addListeners()
  }

  addListeners() {
    this.menuOpen.addEventListener('click', this.clickAction)
    this.menuClose.addEventListener('click', this.clickAction)

    this.menuLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        setTimeout(() => {
          this.menu.classList.remove('open')
          this.menuState = false
          this.menuOpen.setAttribute('aria-expanded', this.menuState)
        }, 650)

        document.querySelector('html').classList.remove('h-noscroll')
      })
    })
  }

  clickAction(e) {
    e.preventDefault()
    this.menu.classList.toggle('open')
    document.querySelector('html').classList.toggle('h-noscroll')

    this.menuState = !this.menuState
    this.menuOpen.setAttribute('aria-expanded', this.menuState)
  }

  getCurrentPageName() {
    const pathArray = window.location.pathname.split('/')
    return pathArray[pathArray.length - 1]
  }

  setActiveMenuItem() {
    this.menuLinks.forEach((menuItem) => {
      const href = menuItem.getAttribute('href')
      if (href === this.currentPage) {
        menuItem.classList.add('active')
      }
    })
  }

  static init() {
    Menu.item = new Menu(document.querySelector('.header'))
  }
}
